type DataListType = {
  label?: string | undefined;
  value?: number | string | undefined;
  status?: any; 
}[];

type Response = {
  id?: number;
  value?: string;
  status?: any;
};

export class FormUtils {
  static convertDataList(data: Response[]): DataListType {
    return data.map((item: Response) => ({
      label: item.value,
      value: item.id,
      status: item.status
    }));
  }


  static convertList2ArrOfObj(data: string[]): DataListType {
    return data.map((item: string, index: number) => ({
      label: item,
      value: index,
    }));
  }
}

export interface SelectOptionType {
  value: number | string;
  label: number | string;
}